import { env } from '../../../../../common/util'

const resultExplainerPresetName = { dev: 'result_explainer', staging: 'result_explainer', prod: 'result_explainer' }
const externalContactUpdateResultExplainerPresetName = {
  dev: 'external_contact_update_result_explainer',
  staging: 'external_contact_update_result_explainer',
  prod: 'external_contact_update_result_explainer',
}

export const RESULT_EXPLAINER_PRESET_NAME = resultExplainerPresetName[env]
export const EXTERNAL_CONTACT_UPDATE_RESULT_EXPLAINER_PRESET_NAME = externalContactUpdateResultExplainerPresetName[env]
